/**
 * Created by stonewang on 2017/8/29.
 */
import {config, request} from 'Utils';

//出入库记录列表
export function storageOutInRecord(param) {
  return request(`${config.server}/api/v1/dms/storageOutInRecord/list`, {
    method: 'post',
    body: param,
  });
}
/*出入库记录导出
 * */
export const exportFun = `${config.server}/api/v1/dms/storageOutInRecord/exportOutIn`;


// WEBPACK FOOTER //
// ./src/service/inventory/records.js